import { patientApi } from '@/api/PatientApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useUpdatePrimaryCard = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ token }: { token: string }) => patientApi.updatePrimaryCard({ token }),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['patient-billing'],
			})
		},
	})
}

export { useUpdatePrimaryCard }
